import * as React from 'react';

import { Message as AIMessage } from '@ai-sdk/react';

import { Message } from '@components/shared/AgentMessage';

interface MessagesListProps {
  messages: AIMessage[];
  messagesEndRef: React.RefObject<HTMLDivElement>;
}

export const MessagesList: React.FC<MessagesListProps> = ({ messages, messagesEndRef }) => {
  const lastMessage = messages.length > 0 ? messages[messages.length - 1] : null;
  const shouldShowLoading = lastMessage?.role === 'user';

  return (
    <div className='flex-1 space-y-4 overflow-y-auto p-6'>
      {messages.map((message, index) => {
        const isLastMessage = index === messages.length - 1;
        const loading = isLastMessage && shouldShowLoading;
        const isUserMessage = message.role === 'user';

        return <Message key={message.id} message={message} loading={loading} isUserMessage={isUserMessage} />;
      })}
      <div ref={messagesEndRef} />
    </div>
  );
};
